module["exports"] = [
  "#####"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/postcode.js
// module id = 1205
// module chunks = 1